<template>
  <div id="app">
    <PopinError v-if="popinError" />
    <router-view />
  </div>
</template>

<script>
import PopinError from "@/components/Popin/PopinError";
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
  name: "App",
  components: {
    PopinError
  },
  computed: {
    ...mapState({
      isConnected: state => state.auth.isConnected,
      bodyNoScroll: state => state.display.bodyNoScroll,
      popinError: state => state.display.popinError,
      shoes: state => state.shoes
    }),
    ...mapGetters({
      getErrorOnStorage: "getErrorOnStorage"
    })
  },
  methods: {
    ...mapMutations({
      updatePopinError: "updatePopinError"
    })
  },
  mounted() {
    if (!this.isConnected) {
      this.$router.push("/");
    }

    // Listen bodyOnScroll change
    this.$store.watch(
      state => state.display.bodyNoScroll,
      () => {
        const body = document.getElementsByTagName("body")[0];
        if (this.bodyNoScroll) body.classList.add("unscroll");
        else body.classList.remove("unscroll");
      }
    );

    // if (this.getErrorOnStorage === "true") {
    //   console.log("overloaded servers");
    //   this.updatePopinError(true);
    // }

    // WORK ON JSON
    // console.log(this.shoes);
    // this.shoes.map((shoe, i) => {
    //   shoe.id =
    //     i +
    //     "-" +
    //     shoe.name
    //       .replace(/ /g, "")
    //       .replace(/'/g, "")
    //       .toLowerCase();
    //   return shoe;
    // });
    // console.log(JSON.stringify(this.shoes));
  },
  updated() {
    if (!this.isConnected) {
      this.$router.push("/");
    }
  }
};
</script>
